import type { ReactNode } from "react";
import { Icon, type IconName } from "./Icon";

export type Status = "wait" | "paid" | "ambiguous" | "notfound" | "attention" | "error" | "sold" | "shelf" | "returnbox" | "neutral";

const KONFIG: Record<Status, { ton: "petrol" | "success" | "attention" | "danger" | "neutral"; icon: IconName; text: string }> = {
  wait: { ton: "petrol", icon: "clock", text: "Wartet auf Zahlung" },
  paid: { ton: "success", icon: "circle-check", text: "Bezahlt" },
  ambiguous: { ton: "attention", icon: "circle-help", text: "Mehrdeutig" },
  notfound: { ton: "attention", icon: "search", text: "Nicht gefunden" },
  attention: { ton: "attention", icon: "triangle-alert", text: "Achtung" },
  error: { ton: "danger", icon: "circle-alert", text: "Fehler" },
  sold: { ton: "success", icon: "tag", text: "Verkauft" },
  shelf: { ton: "neutral", icon: "library", text: "Im Regal" },
  returnbox: { ton: "attention", icon: "package", text: "Rückgabe-Kiste" },
  neutral: { ton: "neutral", icon: "info", text: "" },
};

/** Status immer als Farbe + Symbol + Text. `children` ersetzt den Standardtext durch einen konkreteren. */
export function StatusBadge({ status, size = "md", children }: { status: Status; size?: "md" | "lg"; children?: ReactNode }) {
  const k = KONFIG[status];
  return (
    <span className={["rg-badge", `rg-badge--${k.ton}`, size === "lg" && "rg-badge--lg"].filter(Boolean).join(" ")}>
      <Icon name={k.icon} size={size === "lg" ? 20 : 16} />
      {children ?? k.text}
    </span>
  );
}
